<template>
  <div id="footer">
    <v-footer flat color="darken1" min-height="230px" dark>
      <!-- app -->
      <v-container fluid>
        <v-row justify="space-around">
          <v-col cols="5">
            <v-row
              ><a href="#spot_inquiry" class="pl-4" @click="toSection()">{{
                $t("label.self_pick_spot")
              }}</a></v-row
            >
            <v-row
              ><a href="#CompanyInfo" class="pl-4" @click="toSection()">{{
                $t("label.company_profile")
              }}</a></v-row
            >
            <v-row
              ><a href="#CustomerNotice" class="pl-4" @click="toSection()">{{
                $t("label.customer_notice")
              }}</a></v-row
            >
            <v-row
              ><a href="#ProhibitedGoods" class="pl-4" @click="toSection()">{{
                $t("label.prohibited_goods")
              }}</a></v-row
            >
            <v-row
              ><a href="#Pricing" class="pl-4" @click="toSection()">{{
                $t("label.pricing")
              }}</a></v-row
            >
            <v-row>
              <!-- <router-link :to="{ path: '/tutorial' }">{{$t("label.tutorial")}}</router-link> -->
              <a class="pl-4" @click="toPage('tutorial')">{{
                $t("label.tutorial")
              }}</a>
            </v-row>
            <v-row><a class="pl-4" @click="toPage('news')">{{
                $t("label.news")
              }}</a></v-row
            >
            <v-row
              ><a class="pl-4" @click="toPage('faq')">{{
                $t("label.faq")
              }}</a></v-row
            >
          </v-col>
          <v-col cols="6">
            <v-row>{{ $t("label.contact_person") }}:青蛙客服專員</v-row>
            <v-row>{{ $t("label.address") }}: 古洞路DD98地段</v-row>
            <v-row
              >{{ $t("label.email") }}:
              <a href="mailto:cs@frogigo.co">cs@frogigo.co</a></v-row
            >
            <v-row
              ><v-btn
                text
                class="px-0"
                href="https://wa.me/85267470369"
                target="_blank"
                rel="noopener"
                ><v-icon>{{ mdiWhatsapp }}</v-icon
                >67470369</v-btn
              ></v-row
            >
            <v-row
              ><v-btn
                text
                class="px-0 no-uppercase"
                href="https://www.facebook.com/FrogiGo.HK/"
                target="_blank"
                rel="noopener"
                ><v-icon>{{ mdiFacebook }}</v-icon
                >FrogiGo.HK</v-btn
              ></v-row
            >
            <v-row
              ><v-btn
                text
                class="px-0 no-uppercase"
                href="https://www.youtube.com/channel/UCl5DV1NdUgcvIuNp216Hzyw"
                target="_blank"
                rel="noopener"
                ><v-icon>{{ mdiYoutube }}</v-icon
                >青蛙集運官方頻道</v-btn
              ></v-row
            >
            <div v-if="!isFlutter" class="pt-6">
              <v-row>
                {{ $t("label.ios") }}
              </v-row>
              <v-row>
                <v-btn
                  icon
                  class="ml-11"
                  href="https://apps.apple.com/hk/app/frogigo/id1609032124"
                  target="_blank"
                >
                  <v-img
                    max-width="120"
                    width="100%"
                    contain
                    src="@/assets/apple_appstore_badge.jpg"
                  ></v-img>
                </v-btn>
              </v-row>
              <v-row>
                {{ $t("label.android") }}
              </v-row>
              <v-row>
                <v-btn
                  icon
                  class="ml-11"
                  href="https://play.google.com/store/apps/details?id=com.dtslog.frogigo&hl=zh_HK"
                  target="_blank"
                >
                  <v-img
                    max-width="120"
                    width="100%"
                    contain
                    src="@/assets/google_play_badge.jpg"
                  ></v-img>
                </v-btn>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-footer>
      <v-row dense class="mx-auto justify-center">
        {{ $t("detail.copyright", { year: new Date().getFullYear() }) }}

        <a class="pl-4" @click="toPage('term_of_service')">{{
          $t("detail.term_of_service")
        }}</a>
        <a class="pl-4" @click="toPage('privacy_policy')">{{
          $t("detail.privacy_policy")
        }}</a>
        <span class="ml-4" v-show="!isFlutter">粵ICP備2021118798號</span>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import { mdiWhatsapp, mdiFacebook, mdiYoutube } from "@mdi/js";
export default {
  methods: {
    toPage(page) {
      this.$router.push({ name: page }).catch((error) => {
        console.log(error);
      });
    },
    toSection() {
      this.$router.push({ name: "home" }).catch((error) => {
        console.log(error);
      });
    },
  },
  name: "Footer",
  data: () => ({
    // svg icons
    mdiWhatsapp,
    mdiFacebook,
    mdiYoutube,
  }),
  computed: {
    isFlutter() {
      return localStorage.getItem("flutter") == "true";
    },
  },
};
</script>

<style scoped>
.no-uppercase {
  text-transform: none;
}

a:link {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

</style>
